






































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {

    @Prop( { type: String } )
    public Titulo: string;

    @Prop( { type: Boolean } )
    public Ayuda: boolean;
    @Watch( 'Ayuda' )
    onAyuda() {
        this.ayuda = this.Ayuda;
    }
    public ayuda: boolean = false;

    @Prop( { type: Boolean } )
    public Cargando: boolean;
    @Watch( 'Cargando' )
    onCargando() {
        this.cargando = this.Cargando;
    }
    public cargando: boolean = false;



    @Prop( { type: Boolean } )
    public value: boolean;

    @Watch( 'value', { immediate: true } )
    onIndex() {
        this.Abierto = this.value;
    }



    public abierto: boolean = false;
    public get Abierto(): boolean {
        return this.abierto;
    }
    public set Abierto( x: boolean ) {
        this.abierto = x;
        this.$emit( 'input', this.Abierto );

    }
}
